const ChatIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16.4868C11.3359 16.4868 10.6719 16.2915 10.125 15.8618L2 9.53369V18.3618C2 19.4165 2.82031 20.2368 3.875 20.2368H20.125C21.1406 20.2368 22 19.4165 22 18.3618V9.53369L13.8359 15.8618C13.2891 16.2915 12.625 16.4868 12 16.4868ZM2.625 8.43994L10.9062 14.8853C11.5312 15.354 12.4297 15.354 13.0547 14.8853L21.3359 8.43994C21.7266 8.12744 22 7.61963 22 7.11182C22 6.09619 21.1406 5.23682 20.125 5.23682H3.875C2.82031 5.23682 2 6.09619 2 7.11182C2 7.61963 2.23438 8.12744 2.625 8.43994Z"
        fill="white"
      />
    </svg>
  );
};
export default ChatIcon;
